export const ARCADE__SET_ARCADE = 'ARCADE__SET_ARCADE';
export const ARCADE__SET_ARCADE_VALUE = 'ARCADE__SET_ARCADE_VALUE';
export const ARCADE__CLEAR_ARCADE = 'ARCADE__CLEAR_ARCADE';

export const GET_ARCADE = 'API_FETCH__GET_ARCADE';
export const POST_ARCADE = 'API_FETCH__POST_ARCADE';
export const PUT_ARCADE = 'API_FETCH__PUT_ARCADE';

export const ARCADE_UPDATE_BUNDLE = 'ARCADE__UPDATE_BUNDLE';
export const SET_STATE = 'arcade/setState';
